import { STRUCTURE_EDITOR_BBX_THRESHOLDS } from '../../../../shared/constants.js';

/**
 * Recursively check if any bounding box has confidence below the threshold.
 */
export function checkRecursiveTasksForLowConfidence(
  tasks: any[],
  threshold: number = STRUCTURE_EDITOR_BBX_THRESHOLDS.HIGH_CONFIDENCE,
): boolean {
  if (!Array.isArray(tasks)) return false;

  const walk = (node: any): boolean => {
    if (!node || typeof node !== 'object') return false;

    // Check if this node has low-confidence BBX
    if (Array.isArray(node.descriptionBoundingBoxes)) {
      for (const box of node.descriptionBoundingBoxes) {
        const confidence = Number(box?.confidence ?? 1);
        if (Number.isFinite(confidence) && confidence < threshold) {
          return true;
        }
      }
    }

    // Also trigger canvas open for semantic description issues (missing info, cutoff text, etc.)
    if (Array.isArray(node.descriptionWarningCodes) && node.descriptionWarningCodes.length > 0) {
      return true;
    }

    // Recursively check subtasks
    if (Array.isArray(node.subtasks)) {
      for (const subtask of node.subtasks) {
        if (walk(subtask)) return true;
      }
    }

    return false;
  };

  for (const task of tasks) {
    if (walk(task)) return true;
  }

  return false;
}
